import { createContext } from "react";
import { useResearchSession } from "../hooks/useResearchSession";

/**
 * Context que expone el estado de la sesión de research a toda la app.
 *
 * Sin este Provider, cada componente que hiciera useResearchSession()
 * tendría su PROPIA instancia del hook → cada uno con su propio estado.
 * Eso significaría que Step1 no podría ver lo que el usuario escribió en
 * Step2, etc.
 *
 * Con el Provider: una sola instancia del hook, todos los hijos leen
 * el mismo state vía useSession().
 */
export const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  // Una sola llamada al hook — toda la app comparte este state
  const session = useResearchSession();
  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
}
